var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-bar__vue" }, [
    _c("form", { staticClass: "search-bar__product-form" }, [
      _c("label", [
        _c("span", {
          staticClass: "screen-reader-text",
          domProps: { innerHTML: _vm._s(_vm.translations.search) }
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchInput,
              expression: "searchInput"
            }
          ],
          staticClass: "search-field",
          attrs: {
            type: "search",
            name: "s",
            placeholder: _vm.translations.search
          },
          domProps: { value: _vm.searchInput },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchInput = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("input", {
        staticClass: "search-submit search-bar__vue-submit",
        attrs: { type: "submit" },
        domProps: { value: _vm.translations.search },
        on: { click: _vm.preventSubmission }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "search-bar__results",
        class: {
          "search-bar__results--loading": _vm.loading,
          "search-bar__results--has-results": _vm.has_results
        }
      },
      [
        _c("div", { staticClass: "search-bar__scroll-container" }, [
          _vm.loading
            ? _c("div", {
                staticClass: "vue__loader search-bar__results-loader"
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6 search-bar__results-col" }, [
                _vm.loading === false && _vm.has_results === true
                  ? _c("div", {
                      staticClass: "search-bar__results-title",
                      domProps: { innerHTML: _vm._s(_vm.translations.products) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.results_catalog.post_results
                  ? _c(
                      "ul",
                      { staticClass: "search-bar__results-list" },
                      _vm._l(_vm.results_catalog.post_results, function(post) {
                        return _c("li", { staticClass: "search-bar__result" }, [
                          _c(
                            "a",
                            {
                              staticClass: "search-bar__result-link",
                              attrs: { href: post.link }
                            },
                            [
                              post.meta.image
                                ? _c(
                                    "figure",
                                    {
                                      staticClass: "search-bar__result-figure"
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "search-bar__result-image",
                                        attrs: {
                                          src: post.meta.image,
                                          alt: post.title.rendered
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "search-bar__result-content" },
                                [
                                  post.title
                                    ? _c("div", {
                                        staticClass: "search-bar__post-title",
                                        domProps: {
                                          innerHTML: _vm._s(post.title.rendered)
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  post.default_code_stimmt
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "search-bar__post-code"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(post.default_code_stimmt) +
                                              "\n                                        "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 search-bar__results-col" }, [
                _vm.loading === false && _vm.has_results === true
                  ? _c("div", {
                      staticClass: "search-bar__results-title",
                      domProps: { innerHTML: _vm._s(_vm.translations.content) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.results_content
                  ? _c(
                      "ul",
                      { staticClass: "search-bar__results-list" },
                      _vm._l(_vm.results_content.slice(0, 15), function(post) {
                        return _c("li", { staticClass: "search-bar__result" }, [
                          post.type !== "catalogus"
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "search-bar__result-content-link",
                                  attrs: { href: post.link }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(post.title.rendered)
                                    }
                                  }),
                                  _vm._v(" "),
                                  post.type
                                    ? _c("span", {
                                        staticClass: "search-bar__result-type",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.postType(post.type)
                                          )
                                        }
                                      })
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _vm.loading === false && _vm.has_results === true
              ? _c("div", { staticClass: "row search-bar__buttons" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _vm.search_catalog_url
                      ? _c("a", {
                          staticClass: "button button--ghost",
                          attrs: { href: _vm.search_catalog_url },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.translations.all_search_results
                            )
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6" }, [
                    _vm.search_content_url
                      ? _c("a", {
                          staticClass: "button button--ghost",
                          attrs: { href: _vm.search_content_url },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.translations.all_search_results
                            )
                          }
                        })
                      : _vm._e()
                  ])
                ])
              : _vm._e()
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }